import { BsShieldCheck } from "react-icons/bs";
import { FaGears } from "react-icons/fa6";
import { GoQuestion } from "react-icons/go";
import { PiPackageLight, PiPlugsConnectedLight } from "react-icons/pi";
import { NavLink } from "react-router-dom";

const MAIN_MENUS = [
  {
    name: "Application 注册",
    path: "/register",
    icon: <PiPlugsConnectedLight size={21} />,
  },
  {
    name: "Production 生产",
    path: "/production",
    icon: <FaGears size={21} />,
  },
  {
    name: "Inventory 库存",
    path: "/inventory",
    icon: <PiPackageLight size={24} />,
  },
  { name: "ESG 环境社会治理", path: "/esg", icon: <BsShieldCheck /> },
  { name: "Support 支持", path: "/support", icon: <GoQuestion /> },
];

const Menu = () => {
  return (
    <div className="p-3">
      {MAIN_MENUS.map((i) => (
        <NavLink
          key={i.path}
          className={({ isActive }) => `
            ${isActive ? "bg-gray-300 dark:bg-gray-700" : ""}
            px-3 py-3 lg:py-2 rounded-xl font-semibold w-full flex space-x-2 items-center text-base
            `}
          to={i.path}
        >
          <span className="w-6 text-xl lg:text-lg">{i.icon}</span>
          <span>{i.name}</span>
        </NavLink>
      ))}
    </div>
  );
};

export default Menu;
